import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import { actions, getExtensionTranslation } from '../../sdk';
import { MenuItemName } from '../../sdk.types';
import './extension-menu-item.style.scss';
export const ExtensionMenuLink = ({ keyProp, extensionName, menuType, translation, iconSRC, start, label, extensionInfo, isDisabledSubject, }) => {
    const [info, setInfo] = useState(null);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const onClickHandler = useCallback(async (e) => {
        e.preventDefault();
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        try {
            await actions.onClickExtensionItem(extensionName, menuType, start);
        }
        catch (errorMessage) {
            throw new Error(errorMessage);
        }
        finally {
            setIsLoading(false);
        }
    }, [extensionName, menuType, start, isLoading, setIsLoading]);
    useEffect(() => {
        async function getInfoExtension() {
            setInfo(await extensionInfo());
        }
        if (extensionInfo) {
            void getInfoExtension();
        }
    }, []);
    useEffect(() => {
        if (!isDisabledSubject) {
            return () => undefined;
        }
        const isDisabledSubscription = isDisabledSubject.subscribe((value) => setIsDisabled(value));
        return () => {
            isDisabledSubscription.unsubscribe();
        };
    }, []);
    return (<div className={classNames('main-menu__item', {
            active: keyProp === MenuItemName.SCREENSHARING || isLoading,
            disabled: isDisabled,
        })}>
      <a className="main-menu__link" onClick={isLoading || isDisabled ? undefined : onClickHandler} data-test-id={`sidebar-extension-${keyProp}`}>
        {iconSRC && (<i className={classNames('main-menu__text-icon', 'icon')}>
            {iconSRC()}
          </i>)}

        <div className="main-menu__text-wrapper">
          <div>
            <span className="main-menu__text">
              {getExtensionTranslation(translation)}
            </span>
            {Boolean(label) &&
            <span className="main-menu__label">{label}</span>}
          </div>
            {info &&
            <span className="main-menu__info">{info}</span>}
        </div>
      </a>
    </div>);
};
